import Image from 'next/image';

type AvatarImageCircleProps = {
  src: string;
  size?: number;
  alt?: string;
}

const AvatarImageCircle: React.FC<AvatarImageCircleProps> = ({
  src,
  size = 80,
  alt = 'Avatar Image',
}) => {
  return (
    <div
      className="min-w-20 min-h-20 w-20 h-20"
    >
      <Image
        src={src}
        alt={alt}
        width={size}
        height={size}
        data-testid="avatar-image"
        className="object-contain rounded-full min-w-20 min-h-20 w-20 h-20"
      />
    </div>
  );
};

export default AvatarImageCircle;

